import { z } from 'zod';

/** Member status for a given period, file-over-file. */
export const STATUSES = ['green', 'yellow', 'red'] as const;
export const statusSchema = z.enum(STATUSES);
export type Status = (typeof STATUSES)[number];

/** Explicit delta flags attached to a member's status for a period. */
export const FLAGS = [
  'NEW',
  'COMMISSION_CHANGED',
  'DATA_CHANGED',
  'DROPPED',
  'REAPPEARED',
  'REAPPEARED_WITH_DELTA',
  // Carrier clawed back commission this period (negative commission amount).
  'CHARGEBACK',
  // The carrier's OWN file flagged this member as terminating (a term-date/status
  // on their record this period) — a present member on their way out.
  'TERMINATING',
  // A dropped member the carrier had flagged as terminating in their last
  // statement — a CONFIRMED termination, vs. an unexplained absence (plain DROPPED).
  'TERMINATED',
] as const;
export const flagSchema = z.enum(FLAGS);
export type Flag = (typeof FLAGS)[number];

/** Per-field delta change classification. */
export const CHANGE_TYPES = ['added', 'removed', 'modified'] as const;
export const changeTypeSchema = z.enum(CHANGE_TYPES);
export type ChangeType = (typeof CHANGE_TYPES)[number];

/** Comparison granularity for reports and the compare view. */
export const GRANULARITIES = ['month', 'quarter', 'year'] as const;
export const granularitySchema = z.enum(GRANULARITIES);
export type Granularity = (typeof GRANULARITIES)[number];

/** Job lifecycle states (mirrors core D1 `jobs.status`). */
export const JOB_STATUSES = ['queued', 'processing', 'completed', 'failed'] as const;
export const jobStatusSchema = z.enum(JOB_STATUSES);
export type JobStatus = (typeof JOB_STATUSES)[number];
